import React, { ReactNode } from "react";
import { hideSplash } from "../components/shared/SplashDone";

interface Props {
    children: ReactNode
}

interface State {
    error?: Error
}

// Inline on purpose: the strings live in a chunk that may be the one that failed to load.
const COPY: Record<string, { message: string, retry: string }> = {
    en: { message: "This page didn't load. Check your connection and try again.", retry: "Try again" },
    es: { message: "La página no se cargó. Revisa tu conexión e inténtalo de nuevo.", retry: "Reintentar" },
    de: { message: "Die Seite hat nicht geladen. Prüf deine Verbindung und versuch es nochmal.", retry: "Nochmal versuchen" },
};

/**
 * Shows a retry screen when a route's code can't be fetched even after the one automatic reload
 * in lazyNamed. Every other error passes through untouched.
 */
export class ChunkErrorBoundary extends React.Component<Props, State> {
    state: State = {};

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    componentDidCatch() {
        // the retry screen, or whatever the error leaves behind, must not stay hidden behind the splash
        hideSplash();
    }

    render() {
        const { error } = this.state;
        if (!error) {
            return this.props.children;
        }
        if (error.name !== "ChunkLoadError") {
            throw error;
        }
        const copy = COPY[navigator.language.slice(0, 2)] || COPY.en;
        return (
            <div style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
                padding: "16px",
                background: "#fff",
                color: "#000",
                textAlign: "center",
                fontSize: "16px",
            }}>
                <div>{copy.message}</div>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        background: "#000",
                        color: "#fff",
                        border: "none",
                        borderRadius: "999px",
                        padding: "10px 20px",
                        fontSize: "14px",
                        fontWeight: 500,
                        cursor: "pointer",
                    }}
                >
                    {copy.retry}
                </button>
            </div>
        );
    }
}
